import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

var _025a2eff = function _025a2eff() {
	return import('../pages/index.vue' /* webpackChunkName: "pages/index" */).then(function (m) {
		return m.default || m;
	});
};
var _446ad7bf = function _446ad7bf() {
	return import('../pages/support/index.vue' /* webpackChunkName: "pages/support/index" */).then(function (m) {
		return m.default || m;
	});
};
var _74d928bd = function _74d928bd() {
	return import('../pages/refused.vue' /* webpackChunkName: "pages/refused" */).then(function (m) {
		return m.default || m;
	});
};
var _64787618 = function _64787618() {
	return import('../pages/panel/index.vue' /* webpackChunkName: "pages/panel/index" */).then(function (m) {
		return m.default || m;
	});
};
var _ece24702 = function _ece24702() {
	return import('../pages/admin/index.vue' /* webpackChunkName: "pages/admin/index" */).then(function (m) {
		return m.default || m;
	});
};
var _49c14da5 = function _49c14da5() {
	return import('../pages/404.vue' /* webpackChunkName: "pages/404" */).then(function (m) {
		return m.default || m;
	});
};
var _078d36fe = function _078d36fe() {
	return import('../pages/admin/feedbacks/index.vue' /* webpackChunkName: "pages/admin/feedbacks/index" */).then(function (m) {
		return m.default || m;
	});
};
var _1e7afdf6 = function _1e7afdf6() {
	return import('../pages/panel/orders/index.vue' /* webpackChunkName: "pages/panel/orders/index" */).then(function (m) {
		return m.default || m;
	});
};
var _5a2e5c3b = function _5a2e5c3b() {
	return import('../pages/panel/faq/index.vue' /* webpackChunkName: "pages/panel/faq/index" */).then(function (m) {
		return m.default || m;
	});
};
var _221aac38 = function _221aac38() {
	return import('../pages/panel/news/index.vue' /* webpackChunkName: "pages/panel/news/index" */).then(function (m) {
		return m.default || m;
	});
};
var _45fe5c3e = function _45fe5c3e() {
	return import('../pages/admin/promotional/index.vue' /* webpackChunkName: "pages/admin/promotional/index" */).then(function (m) {
		return m.default || m;
	});
};
var _516dd3bc = function _516dd3bc() {
	return import('../pages/panel/shops/index.vue' /* webpackChunkName: "pages/panel/shops/index" */).then(function (m) {
		return m.default || m;
	});
};
var _65d6fca0 = function _65d6fca0() {
	return import('../pages/admin/projects/index.vue' /* webpackChunkName: "pages/admin/projects/index" */).then(function (m) {
		return m.default || m;
	});
};
var _5546253f = function _5546253f() {
	return import('../pages/admin/finances/index.vue' /* webpackChunkName: "pages/admin/finances/index" */).then(function (m) {
		return m.default || m;
	});
};
var _2d745d9a = function _2d745d9a() {
	return import('../pages/panel/feedbacks/index.vue' /* webpackChunkName: "pages/panel/feedbacks/index" */).then(function (m) {
		return m.default || m;
	});
};
var _18f7e915 = function _18f7e915() {
	return import('../pages/admin/logs/index.vue' /* webpackChunkName: "pages/admin/logs/index" */).then(function (m) {
		return m.default || m;
	});
};
var _0466c3a6 = function _0466c3a6() {
	return import('../pages/panel/users/index.vue' /* webpackChunkName: "pages/panel/users/index" */).then(function (m) {
		return m.default || m;
	});
};
var _3a9b640b = function _3a9b640b() {
	return import('../pages/admin/orders/index.vue' /* webpackChunkName: "pages/admin/orders/index" */).then(function (m) {
		return m.default || m;
	});
};
var _445db178 = function _445db178() {
	return import('../pages/admin/cpa/index.vue' /* webpackChunkName: "pages/admin/cpa/index" */).then(function (m) {
		return m.default || m;
	});
};
var _61c580a7 = function _61c580a7() {
	return import('../pages/sign/in/index.vue' /* webpackChunkName: "pages/sign/in/index" */).then(function (m) {
		return m.default || m;
	});
};
var _4d894e7e = function _4d894e7e() {
	return import('../pages/panel/mails/index.vue' /* webpackChunkName: "pages/panel/mails/index" */).then(function (m) {
		return m.default || m;
	});
};
var _06af9139 = function _06af9139() {
	return import('../pages/admin/news/index.vue' /* webpackChunkName: "pages/admin/news/index" */).then(function (m) {
		return m.default || m;
	});
};
var _91adcd26 = function _91adcd26() {
	return import('../pages/admin/shops/index.vue' /* webpackChunkName: "pages/admin/shops/index" */).then(function (m) {
		return m.default || m;
	});
};
var _c80d859a = function _c80d859a() {
	return import('../pages/panel/promotional/index.vue' /* webpackChunkName: "pages/panel/promotional/index" */).then(function (m) {
		return m.default || m;
	});
};
var _b2d70352 = function _b2d70352() {
	return import('../pages/admin/tickets/index.vue' /* webpackChunkName: "pages/admin/tickets/index" */).then(function (m) {
		return m.default || m;
	});
};
var _44a6bd10 = function _44a6bd10() {
	return import('../pages/admin/users/index.vue' /* webpackChunkName: "pages/admin/users/index" */).then(function (m) {
		return m.default || m;
	});
};
var _3ea821cc = function _3ea821cc() {
	return import('../pages/panel/tickets/index.vue' /* webpackChunkName: "pages/panel/tickets/index" */).then(function (m) {
		return m.default || m;
	});
};
var _8dc947e8 = function _8dc947e8() {
	return import('../pages/admin/mails/index.vue' /* webpackChunkName: "pages/admin/mails/index" */).then(function (m) {
		return m.default || m;
	});
};
var _25e9d53c = function _25e9d53c() {
	return import('../pages/admin/statistic/old-stuff.vue' /* webpackChunkName: "pages/admin/statistic/old-stuff" */).then(function (m) {
		return m.default || m;
	});
};
var _70dc76da = function _70dc76da() {
	return import('../pages/admin/finances/approved.vue' /* webpackChunkName: "pages/admin/finances/approved" */).then(function (m) {
		return m.default || m;
	});
};
var _37c80726 = function _37c80726() {
	return import('../pages/admin/finances/moderate.vue' /* webpackChunkName: "pages/admin/finances/moderate" */).then(function (m) {
		return m.default || m;
	});
};
var _766a2c9c = function _766a2c9c() {
	return import('../pages/admin/statistic/utm.vue' /* webpackChunkName: "pages/admin/statistic/utm" */).then(function (m) {
		return m.default || m;
	});
};
var _a6c8d394 = function _a6c8d394() {
	return import('../pages/admin/tickets/from-partners/index.vue' /* webpackChunkName: "pages/admin/tickets/from-partners/index" */).then(function (m) {
		return m.default || m;
	});
};
var _0912d3f0 = function _0912d3f0() {
	return import('../pages/panel/statistic/by-links.vue' /* webpackChunkName: "pages/panel/statistic/by-links" */).then(function (m) {
		return m.default || m;
	});
};
var _12e2ef20 = function _12e2ef20() {
	return import('../pages/admin/settings/templates.vue' /* webpackChunkName: "pages/admin/settings/templates" */).then(function (m) {
		return m.default || m;
	});
};
var _a2c5b126 = function _a2c5b126() {
	return import('../pages/admin/shops/cpa-categories/index.vue' /* webpackChunkName: "pages/admin/shops/cpa-categories/index" */).then(function (m) {
		return m.default || m;
	});
};
var _1f8b1109 = function _1f8b1109() {
	return import('../pages/admin/statistic/by-orders.vue' /* webpackChunkName: "pages/admin/statistic/by-orders" */).then(function (m) {
		return m.default || m;
	});
};
var _3b5cee84 = function _3b5cee84() {
	return import('../pages/panel/statistic/by-orders.vue' /* webpackChunkName: "pages/panel/statistic/by-orders" */).then(function (m) {
		return m.default || m;
	});
};
var _58546aca = function _58546aca() {
	return import('../pages/admin/statistic/monitoring.vue' /* webpackChunkName: "pages/admin/statistic/monitoring" */).then(function (m) {
		return m.default || m;
	});
};
var _d4ae4572 = function _d4ae4572() {
	return import('../pages/admin/users/add.vue' /* webpackChunkName: "pages/admin/users/add" */).then(function (m) {
		return m.default || m;
	});
};
var _036e10b3 = function _036e10b3() {
	return import('../pages/panel/news/add.vue' /* webpackChunkName: "pages/panel/news/add" */).then(function (m) {
		return m.default || m;
	});
};
var _0ba00148 = function _0ba00148() {
	return import('../pages/admin/statistic/compensation.vue' /* webpackChunkName: "pages/admin/statistic/compensation" */).then(function (m) {
		return m.default || m;
	});
};
var _1d5dda0b = function _1d5dda0b() {
	return import('../pages/admin/statistic/autocompensation.vue' /* webpackChunkName: "pages/admin/statistic/autocompensation" */).then(function (m) {
		return m.default || m;
	});
};
var _7e077953 = function _7e077953() {
	return import('../pages/admin/mails/push/index.vue' /* webpackChunkName: "pages/admin/mails/push/index" */).then(function (m) {
		return m.default || m;
	});
};
var _18ba7ac7 = function _18ba7ac7() {
	return import('../pages/admin/statistic/by-register.vue' /* webpackChunkName: "pages/admin/statistic/by-register" */).then(function (m) {
		return m.default || m;
	});
};
var _56b5c1cc = function _56b5c1cc() {
	return import('../pages/admin/mails/news/index.vue' /* webpackChunkName: "pages/admin/mails/news/index" */).then(function (m) {
		return m.default || m;
	});
};
var _0f79581a = function _0f79581a() {
	return import('../pages/admin/feedbacks/published.vue' /* webpackChunkName: "pages/admin/feedbacks/published" */).then(function (m) {
		return m.default || m;
	});
};
var _1b104728 = function _1b104728() {
	return import('../pages/admin/finances/corrects.vue' /* webpackChunkName: "pages/admin/finances/corrects" */).then(function (m) {
		return m.default || m;
	});
};
var _04d9329c = function _04d9329c() {
	return import('../pages/panel/feedbacks/moderate.vue' /* webpackChunkName: "pages/panel/feedbacks/moderate" */).then(function (m) {
		return m.default || m;
	});
};
var _50d5a6e1 = function _50d5a6e1() {
	return import('../pages/admin/logs/stat.vue' /* webpackChunkName: "pages/admin/logs/stat" */).then(function (m) {
		return m.default || m;
	});
};
var _e0cd9532 = function _e0cd9532() {
	return import('../pages/admin/users/resellers.vue' /* webpackChunkName: "pages/admin/users/resellers" */).then(function (m) {
		return m.default || m;
	});
};
var _30146f87 = function _30146f87() {
	return import('../pages/panel/statistic/compensation.vue' /* webpackChunkName: "pages/panel/statistic/compensation" */).then(function (m) {
		return m.default || m;
	});
};
var _e47a2fca = function _e47a2fca() {
	return import('../pages/panel/finances/moderate.vue' /* webpackChunkName: "pages/panel/finances/moderate" */).then(function (m) {
		return m.default || m;
	});
};
var _513bf6e5 = function _513bf6e5() {
	return import('../pages/admin/settings/messages.vue' /* webpackChunkName: "pages/admin/settings/messages" */).then(function (m) {
		return m.default || m;
	});
};
var _59a74eba = function _59a74eba() {
	return import('../pages/admin/tickets/my/index.vue' /* webpackChunkName: "pages/admin/tickets/my/index" */).then(function (m) {
		return m.default || m;
	});
};
var _4fe34b64 = function _4fe34b64() {
	return import('../pages/admin/users/admins.vue' /* webpackChunkName: "pages/admin/users/admins" */).then(function (m) {
		return m.default || m;
	});
};
var _202dcec1 = function _202dcec1() {
	return import('../pages/admin/finances/history.vue' /* webpackChunkName: "pages/admin/finances/history" */).then(function (m) {
		return m.default || m;
	});
};
var _8d552f42 = function _8d552f42() {
	return import('../pages/admin/system/test.vue' /* webpackChunkName: "pages/admin/system/test" */).then(function (m) {
		return m.default || m;
	});
};
var _644f2bc2 = function _644f2bc2() {
	return import('../pages/panel/promotional/add.vue' /* webpackChunkName: "pages/panel/promotional/add" */).then(function (m) {
		return m.default || m;
	});
};
var _fbc7a908 = function _fbc7a908() {
	return import('../pages/admin/settings/statuses/index.vue' /* webpackChunkName: "pages/admin/settings/statuses/index" */).then(function (m) {
		return m.default || m;
	});
};
var _377fe26f = function _377fe26f() {
	return import('../pages/admin/projects/add.vue' /* webpackChunkName: "pages/admin/projects/add" */).then(function (m) {
		return m.default || m;
	});
};
var _9d5443da = function _9d5443da() {
	return import('../pages/panel/mails/auto/index.vue' /* webpackChunkName: "pages/panel/mails/auto/index" */).then(function (m) {
		return m.default || m;
	});
};
var _a7df2392 = function _a7df2392() {
	return import('../pages/panel/mails/news/index.vue' /* webpackChunkName: "pages/panel/mails/news/index" */).then(function (m) {
		return m.default || m;
	});
};
var _43c1d93c = function _43c1d93c() {
	return import('../pages/panel/statistic/by-register.vue' /* webpackChunkName: "pages/panel/statistic/by-register" */).then(function (m) {
		return m.default || m;
	});
};
var _5b806062 = function _5b806062() {
	return import('../pages/panel/feedbacks/published.vue' /* webpackChunkName: "pages/panel/feedbacks/published" */).then(function (m) {
		return m.default || m;
	});
};
var _314fce36 = function _314fce36() {
	return import('../pages/admin/mails/templates/index.vue' /* webpackChunkName: "pages/admin/mails/templates/index" */).then(function (m) {
		return m.default || m;
	});
};
var _0a70629b = function _0a70629b() {
	return import('../pages/panel/tickets/add.vue' /* webpackChunkName: "pages/panel/tickets/add" */).then(function (m) {
		return m.default || m;
	});
};
var _453bc78f = function _453bc78f() {
	return import('../pages/admin/logs/node.vue' /* webpackChunkName: "pages/admin/logs/node" */).then(function (m) {
		return m.default || m;
	});
};
var _3f6fe9fe = function _3f6fe9fe() {
	return import('../pages/admin/cpa/moderate.vue' /* webpackChunkName: "pages/admin/cpa/moderate" */).then(function (m) {
		return m.default || m;
	});
};
var _46b8af0f = function _46b8af0f() {
	return import('../pages/admin/statistic/all.vue' /* webpackChunkName: "pages/admin/statistic/all" */).then(function (m) {
		return m.default || m;
	});
};
var _75887b2c = function _75887b2c() {
	return import('../pages/panel/finances/history.vue' /* webpackChunkName: "pages/panel/finances/history" */).then(function (m) {
		return m.default || m;
	});
};
var _a2b85264 = function _a2b85264() {
	return import('../pages/admin/settings/cpa/index.vue' /* webpackChunkName: "pages/admin/settings/cpa/index" */).then(function (m) {
		return m.default || m;
	});
};
var _02b5c977 = function _02b5c977() {
	return import('../pages/panel/statistic/by-money.vue' /* webpackChunkName: "pages/panel/statistic/by-money" */).then(function (m) {
		return m.default || m;
	});
};
var _07cf928a = function _07cf928a() {
	return import('../pages/admin/statistic/by-offers.vue' /* webpackChunkName: "pages/admin/statistic/by-offers" */).then(function (m) {
		return m.default || m;
	});
};
var _3a31172e = function _3a31172e() {
	return import('../pages/admin/statistic/by-devices.vue' /* webpackChunkName: "pages/admin/statistic/by-devices" */).then(function (m) {
		return m.default || m;
	});
};
var _6b9a833c = function _6b9a833c() {
	return import('../pages/panel/users/add.vue' /* webpackChunkName: "pages/panel/users/add" */).then(function (m) {
		return m.default || m;
	});
};
var _a1fc09b6 = function _a1fc09b6() {
	return import('../pages/panel/tickets/my/index.vue' /* webpackChunkName: "pages/panel/tickets/my/index" */).then(function (m) {
		return m.default || m;
	});
};
var _4c5cce7c = function _4c5cce7c() {
	return import('../pages/admin/shops/add.vue' /* webpackChunkName: "pages/admin/shops/add" */).then(function (m) {
		return m.default || m;
	});
};
var _cd56e868 = function _cd56e868() {
	return import('../pages/admin/statistic/by-money.vue' /* webpackChunkName: "pages/admin/statistic/by-money" */).then(function (m) {
		return m.default || m;
	});
};
var _5c572cab = function _5c572cab() {
	return import('../pages/panel/mails/templates/index.vue' /* webpackChunkName: "pages/panel/mails/templates/index" */).then(function (m) {
		return m.default || m;
	});
};
var _1094401e = function _1094401e() {
	return import('../pages/admin/statistic/by-time.vue' /* webpackChunkName: "pages/admin/statistic/by-time" */).then(function (m) {
		return m.default || m;
	});
};
var _4c9f0cf2 = function _4c9f0cf2() {
	return import('../pages/admin/system/migrations.vue' /* webpackChunkName: "pages/admin/system/migrations" */).then(function (m) {
		return m.default || m;
	});
};
var _8b126d70 = function _8b126d70() {
	return import('../pages/admin/news/add.vue' /* webpackChunkName: "pages/admin/news/add" */).then(function (m) {
		return m.default || m;
	});
};
var _681058e1 = function _681058e1() {
	return import('../pages/admin/settings/tickets/index.vue' /* webpackChunkName: "pages/admin/settings/tickets/index" */).then(function (m) {
		return m.default || m;
	});
};
var _06ded2d0 = function _06ded2d0() {
	return import('../pages/panel/mails/add.vue' /* webpackChunkName: "pages/panel/mails/add" */).then(function (m) {
		return m.default || m;
	});
};
var _d79badf2 = function _d79badf2() {
	return import('../pages/admin/feedbacks/moderate.vue' /* webpackChunkName: "pages/admin/feedbacks/moderate" */).then(function (m) {
		return m.default || m;
	});
};
var _30ed2cdb = function _30ed2cdb() {
	return import('../pages/admin/mails/add.vue' /* webpackChunkName: "pages/admin/mails/add" */).then(function (m) {
		return m.default || m;
	});
};
var _1b1cd354 = function _1b1cd354() {
	return import('../pages/admin/shops/categories/index.vue' /* webpackChunkName: "pages/admin/shops/categories/index" */).then(function (m) {
		return m.default || m;
	});
};
var _69f911e8 = function _69f911e8() {
	return import('../pages/admin/system/sync.vue' /* webpackChunkName: "pages/admin/system/sync" */).then(function (m) {
		return m.default || m;
	});
};
var _593bb484 = function _593bb484() {
	return import('../pages/panel/mails/push/index.vue' /* webpackChunkName: "pages/panel/mails/push/index" */).then(function (m) {
		return m.default || m;
	});
};
var _7dd06cca = function _7dd06cca() {
	return import('../pages/panel/faq/add.vue' /* webpackChunkName: "pages/panel/faq/add" */).then(function (m) {
		return m.default || m;
	});
};
var _7b87b5a1 = function _7b87b5a1() {
	return import('../pages/admin/statistic/by-turn.vue' /* webpackChunkName: "pages/admin/statistic/by-turn" */).then(function (m) {
		return m.default || m;
	});
};
var _6cdb4d44 = function _6cdb4d44() {
	return import('../pages/panel/tickets/from-admins/index.vue' /* webpackChunkName: "pages/panel/tickets/from-admins/index" */).then(function (m) {
		return m.default || m;
	});
};
var _c09cd376 = function _c09cd376() {
	return import('../pages/admin/statistic/by-links.vue' /* webpackChunkName: "pages/admin/statistic/by-links" */).then(function (m) {
		return m.default || m;
	});
};
var _4e7809ac = function _4e7809ac() {
	return import('../pages/admin/settings/currency.vue' /* webpackChunkName: "pages/admin/settings/currency" */).then(function (m) {
		return m.default || m;
	});
};
var _fad2dce6 = function _fad2dce6() {
	return import('../pages/admin/promotional/add.vue' /* webpackChunkName: "pages/admin/promotional/add" */).then(function (m) {
		return m.default || m;
	});
};
var _301e84a2 = function _301e84a2() {
	return import('../pages/panel/mails/auto/add.vue' /* webpackChunkName: "pages/panel/mails/auto/add" */).then(function (m) {
		return m.default || m;
	});
};
var _8c1853ba = function _8c1853ba() {
	return import('../pages/admin/shops/categories/add.vue' /* webpackChunkName: "pages/admin/shops/categories/add" */).then(function (m) {
		return m.default || m;
	});
};
var _1489cf6a = function _1489cf6a() {
	return import('../pages/admin/settings/statuses/add.vue' /* webpackChunkName: "pages/admin/settings/statuses/add" */).then(function (m) {
		return m.default || m;
	});
};
var _bd4289e6 = function _bd4289e6() {
	return import('../pages/panel/mails/push/add.vue' /* webpackChunkName: "pages/panel/mails/push/add" */).then(function (m) {
		return m.default || m;
	});
};
var _36fdefe2 = function _36fdefe2() {
	return import('../pages/admin/mails/push/add.vue' /* webpackChunkName: "pages/admin/mails/push/add" */).then(function (m) {
		return m.default || m;
	});
};
var _105acd8c = function _105acd8c() {
	return import('../pages/panel/mails/templates/add.vue' /* webpackChunkName: "pages/panel/mails/templates/add" */).then(function (m) {
		return m.default || m;
	});
};
var _5d954a20 = function _5d954a20() {
	return import('../pages/admin/settings/tickets/add.vue' /* webpackChunkName: "pages/admin/settings/tickets/add" */).then(function (m) {
		return m.default || m;
	});
};
var _4f0d1fc6 = function _4f0d1fc6() {
	return import('../pages/admin/settings/cpa/add.vue' /* webpackChunkName: "pages/admin/settings/cpa/add" */).then(function (m) {
		return m.default || m;
	});
};
var _350c2185 = function _350c2185() {
	return import('../pages/admin/mails/templates/add.vue' /* webpackChunkName: "pages/admin/mails/templates/add" */).then(function (m) {
		return m.default || m;
	});
};
var _0d7c5c7c = function _0d7c5c7c() {
	return import('../pages/admin/shops/cpa-categories/add.vue' /* webpackChunkName: "pages/admin/shops/cpa-categories/add" */).then(function (m) {
		return m.default || m;
	});
};
var _148e4b14 = function _148e4b14() {
	return import('../pages/admin/settings/tickets/edit/_id.vue' /* webpackChunkName: "pages/admin/settings/tickets/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _08eb840a = function _08eb840a() {
	return import('../pages/admin/settings/statuses/edit/_id.vue' /* webpackChunkName: "pages/admin/settings/statuses/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _980e0b28 = function _980e0b28() {
	return import('../pages/panel/mails/templates/edit/_id.vue' /* webpackChunkName: "pages/panel/mails/templates/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _78a545ab = function _78a545ab() {
	return import('../pages/admin/mails/news/edit/_id.vue' /* webpackChunkName: "pages/admin/mails/news/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _0ed66723 = function _0ed66723() {
	return import('../pages/admin/shops/categories/edit/_id.vue' /* webpackChunkName: "pages/admin/shops/categories/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _656fe901 = function _656fe901() {
	return import('../pages/admin/mails/templates/edit/_id.vue' /* webpackChunkName: "pages/admin/mails/templates/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _4c2ff70e = function _4c2ff70e() {
	return import('../pages/panel/mails/push/edit/_id.vue' /* webpackChunkName: "pages/panel/mails/push/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _b2401ff8 = function _b2401ff8() {
	return import('../pages/panel/mails/auto/edit/_id.vue' /* webpackChunkName: "pages/panel/mails/auto/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _08f80d2e = function _08f80d2e() {
	return import('../pages/admin/settings/cpa/edit/_id.vue' /* webpackChunkName: "pages/admin/settings/cpa/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _0ab168ce = function _0ab168ce() {
	return import('../pages/panel/tickets/from-admins/view/_id.vue' /* webpackChunkName: "pages/panel/tickets/from-admins/view/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _57cbbac8 = function _57cbbac8() {
	return import('../pages/admin/tickets/from-partners/view/_id.vue' /* webpackChunkName: "pages/admin/tickets/from-partners/view/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _3b6bbd60 = function _3b6bbd60() {
	return import('../pages/panel/mails/news/edit/_id.vue' /* webpackChunkName: "pages/panel/mails/news/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _17218cc4 = function _17218cc4() {
	return import('../pages/admin/mails/push/edit/_id.vue' /* webpackChunkName: "pages/admin/mails/push/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _1cde1f2c = function _1cde1f2c() {
	return import('../pages/admin/shops/cpa-categories/edit/_id.vue' /* webpackChunkName: "pages/admin/shops/cpa-categories/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _6b9c367f = function _6b9c367f() {
	return import('../pages/admin/users/edit/_id.vue' /* webpackChunkName: "pages/admin/users/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _93fc3174 = function _93fc3174() {
	return import('../pages/panel/tickets/view/_id.vue' /* webpackChunkName: "pages/panel/tickets/view/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _76e5539a = function _76e5539a() {
	return import('../pages/admin/projects/edit/_id/index.vue' /* webpackChunkName: "pages/admin/projects/edit/_id/index" */).then(function (m) {
		return m.default || m;
	});
};
var _60a73adb = function _60a73adb() {
	return import('../pages/admin/tickets/view/_id.vue' /* webpackChunkName: "pages/admin/tickets/view/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _2315a8e4 = function _2315a8e4() {
	return import('../pages/panel/feedbacks/edit/_id.vue' /* webpackChunkName: "pages/panel/feedbacks/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _73a7188c = function _73a7188c() {
	return import('../pages/panel/faq/view/_id/index.vue' /* webpackChunkName: "pages/panel/faq/view/_id/index" */).then(function (m) {
		return m.default || m;
	});
};
var _6a962d1c = function _6a962d1c() {
	return import('../pages/admin/tickets/create/_id.vue' /* webpackChunkName: "pages/admin/tickets/create/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _1ceeecd6 = function _1ceeecd6() {
	return import('../pages/panel/shops/edit/_id.vue' /* webpackChunkName: "pages/panel/shops/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _6860e0dc = function _6860e0dc() {
	return import('../pages/panel/faq/edit/_id.vue' /* webpackChunkName: "pages/panel/faq/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _063e836b = function _063e836b() {
	return import('../pages/admin/mails/edit/_id.vue' /* webpackChunkName: "pages/admin/mails/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _2a923df9 = function _2a923df9() {
	return import('../pages/admin/promotional/edit/_id.vue' /* webpackChunkName: "pages/admin/promotional/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _0f52b9c4 = function _0f52b9c4() {
	return import('../pages/admin/news/edit/_id.vue' /* webpackChunkName: "pages/admin/news/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _8c97298e = function _8c97298e() {
	return import('../pages/admin/feedbacks/edit/_id.vue' /* webpackChunkName: "pages/admin/feedbacks/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _7eca8638 = function _7eca8638() {
	return import('../pages/panel/promotional/edit/_id.vue' /* webpackChunkName: "pages/panel/promotional/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _709f4e96 = function _709f4e96() {
	return import('../pages/panel/mails/edit/_id.vue' /* webpackChunkName: "pages/panel/mails/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _df2b72da = function _df2b72da() {
	return import('../pages/panel/news/edit/_id.vue' /* webpackChunkName: "pages/panel/news/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _5405fcac = function _5405fcac() {
	return import('../pages/panel/users/edit/_id.vue' /* webpackChunkName: "pages/panel/users/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _f1b0832c = function _f1b0832c() {
	return import('../pages/admin/shops/edit/_id.vue' /* webpackChunkName: "pages/admin/shops/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _e5c74fee = function _e5c74fee() {
	return import('../pages/panel/faq/view/_id/add.vue' /* webpackChunkName: "pages/panel/faq/view/_id/add" */).then(function (m) {
		return m.default || m;
	});
};
var _dcdae1ec = function _dcdae1ec() {
	return import('../pages/admin/projects/edit/_id/shops/edit/_shop.vue' /* webpackChunkName: "pages/admin/projects/edit/_id/shops/edit/_shop" */).then(function (m) {
		return m.default || m;
	});
};
var _43e4e59b = function _43e4e59b() {
	return import('../pages/panel/faq/view/_id/edit/_param.vue' /* webpackChunkName: "pages/panel/faq/view/_id/edit/_param" */).then(function (m) {
		return m.default || m;
	});
};
var _13b58873 = function _13b58873() {
	return import('../pages/support/view/_id.vue' /* webpackChunkName: "pages/support/view/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _497e2196 = function _497e2196() {
	return import('../pages/panel/settings/rules_templates/index.vue' /* webpackChunkName: "pages/panel/settings/rules_templates/index" */).then(function (m) {
		return m.default || m;
	});
};
var _b626603c = function _b626603c() {
	return import('../pages/admin/settings/payment_systems.vue' /* webpackChunkName: "pages/admin/settings/payment_systems" */).then(function (m) {
		return m.default || m;
	});
};
var _8d106636 = function _8d106636() {
	return import('../pages/panel/settings/rules_templates/add.vue' /* webpackChunkName: "pages/panel/settings/rules_templates/add" */).then(function (m) {
		return m.default || m;
	});
};
var _5c6859a1 = function _5c6859a1() {
	return import('../pages/panel/settings/rules_templates/edit/_id.vue' /* webpackChunkName: "pages/panel/settings/rules_templates/edit/_id" */).then(function (m) {
		return m.default || m;
	});
};

var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
	// SavedPosition is only available for popstate navigations.
	if (savedPosition) {
		return savedPosition;
	} else {
		var position = {};
		// If no children detected
		if (to.matched.length < 2) {
			// Scroll to the top of the page
			position = { x: 0, y: 0 };
		} else if (to.matched.some(function (r) {
			return r.components.default.options.scrollToTop;
		})) {
			// If one of the children has scrollToTop option set to true
			position = { x: 0, y: 0 };
		}
		// If link has anchor, scroll to anchor by returning the selector
		if (to.hash) {
			position = { selector: to.hash };
		}
		return position;
	}
};

export function createRouter() {
	return new Router({
		mode: 'history',
		base: '/',
		linkActiveClass: 'left-menu-link-active',
		linkExactActiveClass: 'nuxt-link-exact-active',
		scrollBehavior: scrollBehavior,
		routes: [{
			path: "/",
			component: _025a2eff,
			name: "index"
		}, {
			path: "/support",
			component: _446ad7bf,
			name: "support"
		}, {
			path: "/refused",
			component: _74d928bd,
			name: "refused"
		}, {
			path: "/panel",
			component: _64787618,
			name: "panel"
		}, {
			path: "/admin",
			component: _ece24702,
			name: "admin"
		}, {
			path: "/404",
			component: _49c14da5,
			name: "404"
		}, {
			path: "/admin/feedbacks",
			component: _078d36fe,
			name: "admin-feedbacks"
		}, {
			path: "/panel/orders",
			component: _1e7afdf6,
			name: "panel-orders"
		}, {
			path: "/panel/faq",
			component: _5a2e5c3b,
			name: "panel-faq"
		}, {
			path: "/panel/news",
			component: _221aac38,
			name: "panel-news"
		}, {
			path: "/admin/promotional",
			component: _45fe5c3e,
			name: "admin-promotional"
		}, {
			path: "/panel/shops",
			component: _516dd3bc,
			name: "panel-shops"
		}, {
			path: "/admin/projects",
			component: _65d6fca0,
			name: "admin-projects"
		}, {
			path: "/admin/finances",
			component: _5546253f,
			name: "admin-finances"
		}, {
			path: "/panel/feedbacks",
			component: _2d745d9a,
			name: "panel-feedbacks"
		}, {
			path: "/admin/logs",
			component: _18f7e915,
			name: "admin-logs"
		}, {
			path: "/panel/users",
			component: _0466c3a6,
			name: "panel-users"
		}, {
			path: "/admin/orders",
			component: _3a9b640b,
			name: "admin-orders"
		}, {
			path: "/admin/cpa",
			component: _445db178,
			name: "admin-cpa"
		}, {
			path: "/sign/in",
			component: _61c580a7,
			name: "sign-in"
		}, {
			path: "/panel/mails",
			component: _4d894e7e,
			name: "panel-mails"
		}, {
			path: "/admin/news",
			component: _06af9139,
			name: "admin-news"
		}, {
			path: "/admin/shops",
			component: _91adcd26,
			name: "admin-shops"
		}, {
			path: "/panel/promotional",
			component: _c80d859a,
			name: "panel-promotional"
		}, {
			path: "/admin/tickets",
			component: _b2d70352,
			name: "admin-tickets"
		}, {
			path: "/admin/users",
			component: _44a6bd10,
			name: "admin-users"
		}, {
			path: "/panel/tickets",
			component: _3ea821cc,
			name: "panel-tickets"
		}, {
			path: "/admin/mails",
			component: _8dc947e8,
			name: "admin-mails"
		}, {
			path: "/admin/statistic/old-stuff",
			component: _25e9d53c,
			name: "admin-statistic-old-stuff"
		}, {
			path: "/admin/finances/approved",
			component: _70dc76da,
			name: "admin-finances-approved"
		}, {
			path: "/admin/finances/moderate",
			component: _37c80726,
			name: "admin-finances-moderate"
		}, {
			path: "/admin/statistic/utm",
			component: _766a2c9c,
			name: "admin-statistic-utm"
		}, {
			path: "/admin/tickets/from-partners",
			component: _a6c8d394,
			name: "admin-tickets-from-partners"
		}, {
			path: "/panel/statistic/by-links",
			component: _0912d3f0,
			name: "panel-statistic-by-links"
		}, {
			path: "/admin/settings/templates",
			component: _12e2ef20,
			name: "admin-settings-templates"
		}, {
			path: "/admin/shops/cpa-categories",
			component: _a2c5b126,
			name: "admin-shops-cpa-categories"
		}, {
			path: "/admin/statistic/by-orders",
			component: _1f8b1109,
			name: "admin-statistic-by-orders"
		}, {
			path: "/panel/statistic/by-orders",
			component: _3b5cee84,
			name: "panel-statistic-by-orders"
		}, {
			path: "/admin/statistic/monitoring",
			component: _58546aca,
			name: "admin-statistic-monitoring"
		}, {
			path: "/admin/users/add",
			component: _d4ae4572,
			name: "admin-users-add"
		}, {
			path: "/panel/news/add",
			component: _036e10b3,
			name: "panel-news-add"
		}, {
			path: "/admin/statistic/compensation",
			component: _0ba00148,
			name: "admin-statistic-compensation"
		}, {
			path: "/admin/statistic/autocompensation",
			component: _1d5dda0b,
			name: "admin-statistic-autocompensation"
		}, {
			path: "/admin/mails/push",
			component: _7e077953,
			name: "admin-mails-push"
		}, {
			path: "/admin/statistic/by-register",
			component: _18ba7ac7,
			name: "admin-statistic-by-register"
		}, {
			path: "/admin/mails/news",
			component: _56b5c1cc,
			name: "admin-mails-news"
		}, {
			path: "/admin/feedbacks/published",
			component: _0f79581a,
			name: "admin-feedbacks-published"
		}, {
			path: "/admin/finances/corrects",
			component: _1b104728,
			name: "admin-finances-corrects"
		}, {
			path: "/panel/feedbacks/moderate",
			component: _04d9329c,
			name: "panel-feedbacks-moderate"
		}, {
			path: "/admin/logs/stat",
			component: _50d5a6e1,
			name: "admin-logs-stat"
		}, {
			path: "/admin/users/resellers",
			component: _e0cd9532,
			name: "admin-users-resellers"
		}, {
			path: "/panel/statistic/compensation",
			component: _30146f87,
			name: "panel-statistic-compensation"
		}, {
			path: "/panel/finances/moderate",
			component: _e47a2fca,
			name: "panel-finances-moderate"
		}, {
			path: "/admin/settings/messages",
			component: _513bf6e5,
			name: "admin-settings-messages"
		}, {
			path: "/admin/tickets/my",
			component: _59a74eba,
			name: "admin-tickets-my"
		}, {
			path: "/admin/users/admins",
			component: _4fe34b64,
			name: "admin-users-admins"
		}, {
			path: "/admin/finances/history",
			component: _202dcec1,
			name: "admin-finances-history"
		}, {
			path: "/admin/system/test",
			component: _8d552f42,
			name: "admin-system-test"
		}, {
			path: "/panel/promotional/add",
			component: _644f2bc2,
			name: "panel-promotional-add"
		}, {
			path: "/admin/settings/statuses",
			component: _fbc7a908,
			name: "admin-settings-statuses"
		}, {
			path: "/admin/projects/add",
			component: _377fe26f,
			name: "admin-projects-add"
		}, {
			path: "/panel/mails/auto",
			component: _9d5443da,
			name: "panel-mails-auto"
		}, {
			path: "/panel/mails/news",
			component: _a7df2392,
			name: "panel-mails-news"
		}, {
			path: "/panel/statistic/by-register",
			component: _43c1d93c,
			name: "panel-statistic-by-register"
		}, {
			path: "/panel/feedbacks/published",
			component: _5b806062,
			name: "panel-feedbacks-published"
		}, {
			path: "/admin/mails/templates",
			component: _314fce36,
			name: "admin-mails-templates"
		}, {
			path: "/panel/tickets/add",
			component: _0a70629b,
			name: "panel-tickets-add"
		}, {
			path: "/admin/logs/node",
			component: _453bc78f,
			name: "admin-logs-node"
		}, {
			path: "/admin/cpa/moderate",
			component: _3f6fe9fe,
			name: "admin-cpa-moderate"
		}, {
			path: "/admin/statistic/all",
			component: _46b8af0f,
			name: "admin-statistic-all"
		}, {
			path: "/panel/finances/history",
			component: _75887b2c,
			name: "panel-finances-history"
		}, {
			path: "/admin/settings/cpa",
			component: _a2b85264,
			name: "admin-settings-cpa"
		}, {
			path: "/panel/statistic/by-money",
			component: _02b5c977,
			name: "panel-statistic-by-money"
		}, {
			path: "/admin/statistic/by-offers",
			component: _07cf928a,
			name: "admin-statistic-by-offers"
		}, {
			path: "/admin/statistic/by-devices",
			component: _3a31172e,
			name: "admin-statistic-by-devices"
		}, {
			path: "/panel/users/add",
			component: _6b9a833c,
			name: "panel-users-add"
		}, {
			path: "/panel/tickets/my",
			component: _a1fc09b6,
			name: "panel-tickets-my"
		}, {
			path: "/admin/shops/add",
			component: _4c5cce7c,
			name: "admin-shops-add"
		}, {
			path: "/admin/statistic/by-money",
			component: _cd56e868,
			name: "admin-statistic-by-money"
		}, {
			path: "/panel/mails/templates",
			component: _5c572cab,
			name: "panel-mails-templates"
		}, {
			path: "/admin/statistic/by-time",
			component: _1094401e,
			name: "admin-statistic-by-time"
		}, {
			path: "/admin/system/migrations",
			component: _4c9f0cf2,
			name: "admin-system-migrations"
		}, {
			path: "/admin/news/add",
			component: _8b126d70,
			name: "admin-news-add"
		}, {
			path: "/admin/settings/tickets",
			component: _681058e1,
			name: "admin-settings-tickets"
		}, {
			path: "/panel/mails/add",
			component: _06ded2d0,
			name: "panel-mails-add"
		}, {
			path: "/admin/feedbacks/moderate",
			component: _d79badf2,
			name: "admin-feedbacks-moderate"
		}, {
			path: "/admin/mails/add",
			component: _30ed2cdb,
			name: "admin-mails-add"
		}, {
			path: "/admin/shops/categories",
			component: _1b1cd354,
			name: "admin-shops-categories"
		}, {
			path: "/admin/system/sync",
			component: _69f911e8,
			name: "admin-system-sync"
		}, {
			path: "/panel/mails/push",
			component: _593bb484,
			name: "panel-mails-push"
		}, {
			path: "/panel/faq/add",
			component: _7dd06cca,
			name: "panel-faq-add"
		}, {
			path: "/admin/statistic/by-turn",
			component: _7b87b5a1,
			name: "admin-statistic-by-turn"
		}, {
			path: "/panel/tickets/from-admins",
			component: _6cdb4d44,
			name: "panel-tickets-from-admins"
		}, {
			path: "/admin/statistic/by-links",
			component: _c09cd376,
			name: "admin-statistic-by-links"
		}, {
			path: "/admin/settings/currency",
			component: _4e7809ac,
			name: "admin-settings-currency"
		}, {
			path: "/admin/promotional/add",
			component: _fad2dce6,
			name: "admin-promotional-add"
		}, {
			path: "/panel/mails/auto/add",
			component: _301e84a2,
			name: "panel-mails-auto-add"
		}, {
			path: "/admin/shops/categories/add",
			component: _8c1853ba,
			name: "admin-shops-categories-add"
		}, {
			path: "/admin/settings/statuses/add",
			component: _1489cf6a,
			name: "admin-settings-statuses-add"
		}, {
			path: "/panel/mails/push/add",
			component: _bd4289e6,
			name: "panel-mails-push-add"
		}, {
			path: "/admin/mails/push/add",
			component: _36fdefe2,
			name: "admin-mails-push-add"
		}, {
			path: "/panel/mails/templates/add",
			component: _105acd8c,
			name: "panel-mails-templates-add"
		}, {
			path: "/admin/settings/tickets/add",
			component: _5d954a20,
			name: "admin-settings-tickets-add"
		}, {
			path: "/admin/settings/cpa/add",
			component: _4f0d1fc6,
			name: "admin-settings-cpa-add"
		}, {
			path: "/admin/mails/templates/add",
			component: _350c2185,
			name: "admin-mails-templates-add"
		}, {
			path: "/admin/shops/cpa-categories/add",
			component: _0d7c5c7c,
			name: "admin-shops-cpa-categories-add"
		}, {
			path: "/admin/settings/tickets/edit/:id?",
			component: _148e4b14,
			name: "admin-settings-tickets-edit-id"
		}, {
			path: "/admin/settings/statuses/edit/:id?",
			component: _08eb840a,
			name: "admin-settings-statuses-edit-id"
		}, {
			path: "/panel/mails/templates/edit/:id?",
			component: _980e0b28,
			name: "panel-mails-templates-edit-id"
		}, {
			path: "/admin/mails/news/edit/:id?",
			component: _78a545ab,
			name: "admin-mails-news-edit-id"
		}, {
			path: "/admin/shops/categories/edit/:id?",
			component: _0ed66723,
			name: "admin-shops-categories-edit-id"
		}, {
			path: "/admin/mails/templates/edit/:id?",
			component: _656fe901,
			name: "admin-mails-templates-edit-id"
		}, {
			path: "/panel/mails/push/edit/:id?",
			component: _4c2ff70e,
			name: "panel-mails-push-edit-id"
		}, {
			path: "/panel/mails/auto/edit/:id?",
			component: _b2401ff8,
			name: "panel-mails-auto-edit-id"
		}, {
			path: "/admin/settings/cpa/edit/:id?",
			component: _08f80d2e,
			name: "admin-settings-cpa-edit-id"
		}, {
			path: "/panel/tickets/from-admins/view/:id",
			component: _0ab168ce,
			name: "panel-tickets-from-admins-view-id"
		}, {
			path: "/admin/tickets/from-partners/view/:id",
			component: _57cbbac8,
			name: "admin-tickets-from-partners-view-id"
		}, {
			path: "/panel/mails/news/edit/:id?",
			component: _3b6bbd60,
			name: "panel-mails-news-edit-id"
		}, {
			path: "/admin/mails/push/edit/:id?",
			component: _17218cc4,
			name: "admin-mails-push-edit-id"
		}, {
			path: "/admin/shops/cpa-categories/edit/:id",
			component: _1cde1f2c,
			name: "admin-shops-cpa-categories-edit-id"
		}, {
			path: "/admin/users/edit/:id?",
			component: _6b9c367f,
			name: "admin-users-edit-id"
		}, {
			path: "/panel/tickets/view/:id?",
			component: _93fc3174,
			name: "panel-tickets-view-id"
		}, {
			path: "/admin/projects/edit/:id?",
			component: _76e5539a,
			name: "admin-projects-edit-id"
		}, {
			path: "/admin/tickets/view/:id?",
			component: _60a73adb,
			name: "admin-tickets-view-id"
		}, {
			path: "/panel/feedbacks/edit/:id?",
			component: _2315a8e4,
			name: "panel-feedbacks-edit-id"
		}, {
			path: "/panel/faq/view/:id?",
			component: _73a7188c,
			name: "panel-faq-view-id"
		}, {
			path: "/admin/tickets/create/:id?",
			component: _6a962d1c,
			name: "admin-tickets-create-id"
		}, {
			path: "/panel/shops/edit/:id?",
			component: _1ceeecd6,
			name: "panel-shops-edit-id"
		}, {
			path: "/panel/faq/edit/:id?",
			component: _6860e0dc,
			name: "panel-faq-edit-id"
		}, {
			path: "/admin/mails/edit/:id?",
			component: _063e836b,
			name: "admin-mails-edit-id"
		}, {
			path: "/admin/promotional/edit/:id?",
			component: _2a923df9,
			name: "admin-promotional-edit-id"
		}, {
			path: "/admin/news/edit/:id?",
			component: _0f52b9c4,
			name: "admin-news-edit-id"
		}, {
			path: "/admin/feedbacks/edit/:id?",
			component: _8c97298e,
			name: "admin-feedbacks-edit-id"
		}, {
			path: "/panel/promotional/edit/:id?",
			component: _7eca8638,
			name: "panel-promotional-edit-id"
		}, {
			path: "/panel/mails/edit/:id?",
			component: _709f4e96,
			name: "panel-mails-edit-id"
		}, {
			path: "/panel/news/edit/:id?",
			component: _df2b72da,
			name: "panel-news-edit-id"
		}, {
			path: "/panel/users/edit/:id?",
			component: _5405fcac,
			name: "panel-users-edit-id"
		}, {
			path: "/admin/shops/edit/:id?",
			component: _f1b0832c,
			name: "admin-shops-edit-id"
		}, {
			path: "/panel/faq/view/:id?/add",
			component: _e5c74fee,
			name: "panel-faq-view-id-add"
		}, {
			path: "/admin/projects/edit/:id?/shops/edit/:shop?",
			component: _dcdae1ec,
			name: "admin-projects-edit-id-shops-edit-shop"
		}, {
			path: "/panel/faq/view/:id?/edit/:param?",
			component: _43e4e59b,
			name: "panel-faq-view-id-edit-param"
		}, {
			path: "/support/view/:id?",
			component: _13b58873,
			name: "support-view-id"
		}, {
			path: "/panel/settings/rules:templates?",
			component: _497e2196,
			name: "panel-settings-rulestemplates"
		}, {
			path: "/admin/settings/payment:systems?",
			component: _b626603c,
			name: "admin-settings-paymentsystems"
		}, {
			path: "/panel/settings/rules:templates?/add",
			component: _8d106636,
			name: "panel-settings-rulestemplates-add"
		}, {
			path: "/panel/settings/rules:templates?/edit/:id?",
			component: _5c6859a1,
			name: "panel-settings-rulestemplates-edit-id"
		}],

		fallback: false
	});
}


//////////////////
// WEBPACK FOOTER
// ./.nuxt/router.js
// module id = ./.nuxt/router.js
// module chunks = 152